import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent,  GridInfo, ModelSchema } from 'tnx-shared';
import { LogSubscribeService } from 'tnx-admin-service/logsubscribe/services';
@Component({
    selector: 'logsubscribe',
    templateUrl: './logsubscribe.component.html',
    styleUrls: ['./logsubscribe.component.scss'],
    providers: [ComponentContextService],
})
export class LogSubscribeComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _logSubscribeService: LogSubscribeService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._logSubscribeService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'customActions', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'templateInstanceId', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'templateCode', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'enabled', dataType: 'boolean', name: 'Sử dụng', fullName: 'Sử dụng', description: 'Sử dụng' }),
			new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'code' }),
			new ColumnSchemaBase({ field: 'customActions' }),
			new ColumnSchemaBase({ field: 'templateInstanceId' }),
			new ColumnSchemaBase({ field: 'templateCode' }),
			new ColumnSchemaBase({ field: 'enabled' }),
			new ColumnSchemaBase({ field: 'currentStateCode' })
        ];

        super.ngOnInit();
    }
}

